import ExpeditionModes from "features/ExpeditionMode/ExpeditionModeList/ExpeditionModes";
const ExpeditionModePage: React.FC = () => {
  return <ExpeditionModes/>
};
export default ExpeditionModePage;
